<template>
  <el-dialog
    :title="`${isAdd ? '新建' : '修改'}黑名单`"
    :visible.sync="visible"
    width="580px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="onClose"
  >
    <el-form label-width="100px" ref="form" :model="form" :rules="rules">
      <el-form-item label="类型" prop="type">
        {{ form.type == 1 ? "嫌疑车辆名单" : "" }}
      </el-form-item>
      <el-form-item label="车牌号" prop="license_plate">
        <el-input
          class="w-96"
          placeholder="请输入车牌号"
          clearable
          v-model="form.license_plate"
          >"></el-input
        >
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          class="w-96"
          type="textarea"
          placeholder="请输入备注"
          :autosize="{ minRows: 2, maxRows: 4 }"
          v-model="form.remark"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="onOk">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import _ from "lodash";
export default {
  data() {
    return {
      form: {},
      rules: {
        license_plate: [
          { required: true, message: "请输入车牌", trigger: "blur" },
          { message: "车牌号格式错误", trigger: "blur", pattern: /^.{7,8}$/ }
        ]
      },
      visible: false
    };
  },
  computed: {
    isAdd() {
      return !this.form.id;
    }
  },
  methods: {
    onOpen(row) {
      if (row) {
        this.$set(this.form, "id", row.id);
        this.$set(this.form, "license_plate", row.license_plate);
        this.$set(this.form, "remark", row.remark);
      }
      this.$set(this.form, "type", _.get(row, "type", 1));
      this.visible = true;
    },
    onClose() {
      this.form = {};
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    onOk() {
      this.$refs.form.validate(v => {
        if (v) {
          this.onSubmit();
        }
      });
    },
    async onSubmit() {
      const url = `/api/queue/admin/${
        this.isAdd ? "create" : "update"
      }_beidou_car`;
      try {
        await this.$common.http({
          url,
          data: this.form
        });
        this.$common.pcToastSuccess("新增成功");
        this.visible = false;
        this.$emit("ok");
      } catch (error) {}
    }
  }
};
</script>

<style lang="less" scoped></style>
